import type { IContinueWatchingCard, PurchaseInfo } from '@setplex/tria-api'
import type { TFunction } from 'i18next'
import type { IContinueWatchingCardFormat } from '~/entities/continue-watching/index.h'

import { MediaTypes, PurchaseInfoContentPurchaseType } from '@setplex/tria-api'
import {
  getLabelPrice,
  getLeftTimeString,
  getProgress,
  getViewedTimeString,
} from '~/shared/tools'

const getShowDescription = ({
  seasonNumber,
  episodeNumber,
  t,
}: {
  t: TFunction
  seasonNumber?: string
  episodeNumber?: string
}): string => {
  let subtitleTranslation = ''

  if (episodeNumber)
    subtitleTranslation = t('episode_shortened', {
      number: episodeNumber,
    })

  if (seasonNumber && episodeNumber)
    subtitleTranslation = t('season_episode_shortened', {
      episode_number: episodeNumber,
      season_number: seasonNumber,
    })

  return subtitleTranslation
}

export const formatContinueWatchingItem = (
  {
    duration,
    stoppedTime,
    contentType,
    seasonNumber,
    episodeNumber,
    purchaseInfo,
    free,
    ...rest
  }: IContinueWatchingCard,
  t: TFunction
): IContinueWatchingCardFormat => {
  const formattedSortOrder = getShowDescription({
    seasonNumber,
    episodeNumber,
    t,
  })
  const normalizedPurchaseInfo = purchaseInfo as PurchaseInfo | undefined
  const labelPrice = getLabelPrice({
    purchaseInfo: normalizedPurchaseInfo,
    free,
  })
  const rented =
    normalizedPurchaseInfo?.contentPurchaseType ===
    PurchaseInfoContentPurchaseType.Rented

  return {
    ...rest,
    duration,
    stoppedTime,
    contentType,
    free,
    seasonNumber,
    episodeNumber,
    purchaseInfo: normalizedPurchaseInfo,
    cardDescription:
      contentType === MediaTypes.VOD ? undefined : formattedSortOrder,
    formattedSortOrder:
      contentType === MediaTypes.VOD ? undefined : formattedSortOrder,
    progress: getProgress({ duration, stoppedTime }),
    timeLeft: getLeftTimeString({ duration, stoppedTime, t }),
    viewedTime: getViewedTimeString(stoppedTime),
    labelPrice,
    rented,
  }
}
